module.exports = __webpack_public_path__ + "img/Component 87 – 98@2x.67350e36.png";